// extracted by mini-css-extract-plugin
export default {"items":"EntityAttachment_items__DX6se"};